import { apiInstance, legacyV2Path } from '../index'
import { mapArgs } from 'corp-front-vue-commons/src/utils/functions'

// ride mock
import allRideStatusMock from '../mocks/allRideStatus.json'
import fullRideMock from '../mocks/fullRide.json'

let mockIndex = 0
const fullRide = false

const webcall = {
  getCompany () {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/webcall/company`
    })
  },

  getEmployee (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/webcall/employee`,
      params
    })
  },

  getCostCenter (employeeId, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/webcall/employee/${employeeId}/costcenters`,
      params
    })
  },

  getProject (costCenterId, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/webcall/costcenter/${costCenterId}/projects`,
      params
    })
  },

  get (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/webcall`,
      params
    })
  },

  getById (id) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/webcall/${id}`
    })
  },

  getRideStatus (rideId) {
    const date = new Date().getTime()
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/webcall/${rideId}?_=${date}`
    })
  },

  getCategories (employeeId, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/webcall/employee/${employeeId}/category`,
      params
    })
  },

  create (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2Path()}/webcall`,
      data
    })
  },

  cancel (rideId) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV2Path()}/webcall/${rideId}/cancel`,
      data: { id: rideId }
    })
  },

  delete (rideId) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV2Path()}/webcall/${rideId}/dismiss`
    })
  },

  getWebCallHistoryMock (...args) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        let data = [...fullRideMock]

        if (!fullRide) {
          const ride = allRideStatusMock[mockIndex]
          data = ride ? [{ ...ride }] : []
        }

        resolve({ data: { data } })
        mockIndex++
      }, 1000)
    })
  }
}

export default webcall
